<template>
    <div>
        <div class="modal-header">
            <div class="modal-title">
                <a-icon type="medicine-box" style="margin-right:10px" />
                <span>{{auditName}}</span>
            </div>
        </div>
        <div>
            <!-- 基本信息区独立加载：先到先显示，不被审核记录等慢接口拖住 -->
            <a-spin :spinning="infoLoading" size="large" :tip="loadingText">
                <a-row>
                <a-col :span="4" style="text-align: right;">
                    <p>{{l('audit.planstart')}}:</p>
                </a-col>
                <a-col :span="4">
                    <p>{{'&nbsp;&nbsp;&nbsp;'+Plantime}}</p>
                </a-col>
                <a-col :span="4" style="text-align: right;">
                    <p>{{l('inspector')}}:</p>
                </a-col>
                <a-col :span="4">
                    <p>
                        {{'&nbsp;&nbsp;&nbsp;'}}
                        <span v-if="!isTeamTask">{{ getInspectorDisplay() }}</span>
                        <span v-else>
                            {{ getInspectorDisplay() }}
                            <a-button type="link" size="small" @click="viewTeamMembers" style="margin-left: 8px;">
                                查看成员
                            </a-button>
                        </span>
                    </p>
                </a-col>
                <a-col :span="4" style="text-align: right;" v-if="IsEnabled.templateBarCode">
                    <p>{{l('Barcode')}}:</p>
                </a-col>
                <a-col :span="4" v-if="IsEnabled.templateBarCode">
                    <p>{{'&nbsp;&nbsp;&nbsp;'+(Barcode == null?"":Barcode)}}</p>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="4" style="text-align: right;">
                    <p>{{l('WEStartDate')}}:</p>
                </a-col>
                <a-col :span="4">
                    <p>{{'&nbsp;&nbsp;&nbsp;'+startTime}}</p>
                </a-col>
                <a-col :span="4" style="text-align: right;">
                    <p>{{l('WEEndDate')}}:</p>
                </a-col>
                <a-col :span="4">
                    <p>{{'&nbsp;&nbsp;&nbsp;'+endTime}}</p>
                </a-col>
                <a-col :span="4" style="text-align: right;" v-if="IsEnabled.assitField">
                    <p>{{l('AssitField')}}:</p>
                </a-col>
                <a-col :span="4" v-if="IsEnabled.assitField">
                    <p>{{'&nbsp;&nbsp;&nbsp;'+(AssitField == null?"":AssitField)}}</p>
                </a-col>
            </a-row>
			<a-row>
			    <a-col :span="4" style="text-align: right;" v-if="IsEnabled.filedExt1">
			        <p>{{l('filedExt1')}}:</p>
			    </a-col>
			    <a-col :span="4" v-if="IsEnabled.filedExt1">
			        <p>{{'&nbsp;&nbsp;&nbsp;'+(filedExt1 == null?"":filedExt1)}}</p>
			    </a-col>
			    <a-col :span="4" style="text-align: right;" v-if="IsEnabled.filedExt2">
			        <p>{{l('filedExt2')}}:</p>
			    </a-col>
			    <a-col :span="4" v-if="IsEnabled.filedExt2">
			        <p>{{'&nbsp;&nbsp;&nbsp;'+(filedExt2 == null?"":filedExt2)}}</p>
			    </a-col>
			    <a-col :span="4" style="text-align: right;" v-if="IsEnabled.filedExt3">
			        <p>{{l('filedExt3')}}:</p>
			    </a-col>
				<a-col :span="4" v-if="IsEnabled.filedExt3">
				    <p>{{'&nbsp;&nbsp;&nbsp;'+(filedExt3 == null?"":filedExt3)}}</p>
				</a-col>
			</a-row>
            </a-spin>
        </div>
        <div>
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" :tab="l('auditrecords')">
                    <order-excution :auditID="auditID"></order-excution>
                </a-tab-pane>
                <a-tab-pane key="2" :tab="l('problemrecord')">
                    <order-picking :auditID="auditID" :isEdit="isEdit"></order-picking>
                </a-tab-pane>
            </a-tabs>
        </div>
        <div class="modal-footer" v-if="!isLook">
            <a-button @click="ExportReport">
                {{l('Export')}}
            </a-button>
            <a-button @click="close">
                {{l('Cancel')}}
            </a-button>
        </div>

        <!-- 审核团队查看组件 -->
        <view-audit-team ref="viewAuditTeamModal" v-if="isTeamTask && auditTeamId" />
    </div>
</template>

<script>
    import ModalComponentBase from '../../../shared/component-base/modal-component-base';
    import zh_CN from 'ant-design-vue/lib/locale/zh_CN';
    import { AuditTaskServiceProxy, SystemConfigServiceProxy } from '../../../shared/service-proxies';
    import OrderExcution from "./OrderExcution/OrderExcution.vue";
    import OrderPicking from "./OrderPicking/OrderPicking.vue";
    import ViewAuditTeam from "../audit-team/view-audit-team.vue";
    import moment from "moment";
    import { Dic, fileDownloadService } from "../../../shared/utils";

    let _this;
    //扩展字段配置缓存（进程级，5分钟）：弹窗每次打开都请求该配置且几乎不变
    let filedExtSettingsCache = { value: null, at: 0 };
    export default {
        name: 'audit-task-view',
        mixins: [ModalComponentBase],
        components: {
            OrderExcution,
            OrderPicking,
            'view-audit-team': ViewAuditTeam,
        },
        created() {
            this.fullData(); // 模态框必须,填充数据到data字段
            this.AuditTaskServiceProxy = new AuditTaskServiceProxy(this.$apiUrl, this.$api);
			this.SystemConfigServiceProxy = new SystemConfigServiceProxy(this.$apiUrl, this.$api);
            this._fileDownloadService = fileDownloadService;
        },
        mounted() {
            this.getData();
			this.getIsEnable();
        },
        data() {
            return {
                zh_CN,
                isEdit: false,//是否是编辑
                isLook: false,//是否是查看
                id: undefined,
                inspectorName: undefined,
                auditTeamName: undefined,
                inspectorId: undefined,
                auditTeamId: undefined,
                isTeamTask: undefined, // 是否为团队任务
                auditTemplateName: undefined,
                startTime: undefined,
                endTime: undefined,
                auditID: undefined,
                auditName: undefined,
                Plantime: undefined,
                Barcode: undefined,
                AssitField: undefined,
				filedExt1: undefined,
				filedExt2: undefined,
				filedExt3: undefined,
				IsEnabled: {
					filedExt1: false,
					filedExt2: false,
					filedExt3: false,
					templateBarCode: false,
					assitField: false
				},
				infoLoading: false//基本信息区独立加载状态
            }
        },
        computed: {
            //加载动画文案（跟随应用语言）
            loadingText() {
                try {
                    const lang = window.abp && abp.localization && abp.localization.currentLanguage
                        ? abp.localization.currentLanguage.name : 'zh-Hans';
                    return lang.indexOf('zh') === 0 ? '数据加载中…' : 'Loading...';
                } catch (e) {
                    return '数据加载中…';
                }
            }
        },
        methods: {
            // 根据审核任务类型显示负责人名称
            getInspectorDisplay() {
                if (this.isTeamTask) {
                    // 团队审核任务
                    const teamName = this.auditTeamName || (this.auditTeamId ? `团队ID: ${this.auditTeamId}` : '');
                    return teamName;
                } else {
                    // 个人审核任务
                    return this.inspectorName || (this.inspectorId ? `用户ID: ${this.inspectorId}` : '');
                }
            },

            ExportReport() {
                this.isLoading = true;
                this.AuditTaskServiceProxy.getToExcelByExportReport(
                    this.id
                ).finally(() => {
                    this.isLoading = false;
                }).then(res => {
                    this._fileDownloadService.downloadTempFile(res);
                })
            },

            getData() {
                this.infoLoading = true;
                this.AuditTaskServiceProxy.getById(
                    this.id
                ).finally(() => {
                    this.infoLoading = false;
                }).then(res => {
                    this.auditName = res.name;
                    this.auditID = this.id;
                    this.inspectorName = res.inspectorName;
                    this.auditTeamName = res.auditTeamName;
                    this.inspectorId = res.inspectorId;
                    this.auditTeamId = res.auditTeamId;
                    this.isTeamTask = res.isTeamTask;
                    this.auditTemplateName = res.auditTemplateName;
                    this.startTime = res.startTime ? moment(res.startTime).format('YYYY-MM-DD HH:mm') : "";
                    this.endTime = res.endTime ? moment(res.endTime).format('YYYY-MM-DD HH:mm') : "";
                    this.Plantime = res.fomartDateTime;
                    this.Barcode = res.templateBarCode;
                    this.AssitField = res.assitField;
					this.filedExt1 = res.filedExt1;
					this.filedExt2 = res.filedExt2;
					this.filedExt3 = res.filedExt3;
                })
            },
			
			//获取是否启用扩展字段（带进程级缓存，避免每次打开弹窗都请求）
			getIsEnable() {
				if (filedExtSettingsCache.value !== null && Date.now() - filedExtSettingsCache.at < 5 * 60 * 1000) {
					this.IsEnabled = filedExtSettingsCache.value;
					return;
				}
				this.SystemConfigServiceProxy.getFiledExtSettings(
				).then(res => {
					this.IsEnabled = res;
					filedExtSettingsCache.value = res;
					filedExtSettingsCache.at = Date.now();
				})
			},

            // 查看团队成员
            viewTeamMembers() {
                if (!this.auditTeamId) {
                    this.$message.warning('该审核任务没有关联的团队');
                    return;
                }

                // 安全检查：确保组件和方法存在
                if (this.$refs.viewAuditTeamModal && typeof this.$refs.viewAuditTeamModal.open === 'function') {
                    this.$refs.viewAuditTeamModal.open(this.auditTeamId, true); // 传入 true 表示只读模式
                } else {
                    console.error('团队查看组件未正确加载');
                    this.$message.error('团队查看组件加载失败，请刷新页面重试');
                }
            },
        }
    }
</script>

<style>
</style>